import { Box, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../../api/api';
import { ExoAutoCompleteSelector } from '../../exo/ExoAutoCompleteSelector';
import LabeledBox from '../../special/LabeledBox';
import { createElement } from 'react';
import ExoAvatar from '../../exo/ExoAvatar';

export const TypeAutoCompleteClient = ({
  updateValidationOnChange,
  dataCollection,
  field,
  errors,
  size,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const config = useConfig();

  const typeKey = field.typeKey || field.key + 'Type';

  function handleChange(data, type) {
    updateValidationOnChange(
      [field.key],
      { [field.key]: data, [typeKey]: type },
      true
    );
  }

  const typeMap = {
    personLead: PersonLead,
    companyLead: CompanyLead,
    person_lead: PersonLead,
    company_lead: CompanyLead,
    company: Company,
    contact: Contact,
    user: User,
  };

  if (dataCollection[field.key])
    return (
      <LabeledBox
        label={field.label}
        size={size}
        onClick={() =>
          updateValidationOnChange(
            [field.key],
            { [field.key]: null, [typeKey]: null },
            true
          )
        }
        sx={{
          ':hover': {
            bgcolor: colors.error + '30',
          },
        }}
      >
        {createElement(typeMap[dataCollection[typeKey]], {
          data: dataCollection[field.key],
          size,
        })}
      </LabeledBox>
    );
  return (
    <ExoAutoCompleteSelector
      multiselect={field.multiselect}
      selection={dataCollection[field.key]}
      onSelectionChange={handleChange}
      searchParams={field.searchParams}
      label={field.label}
    />
  );
};

const Company = ({ data, size }) => {
  const { logo, name, nameShort } = data;
  return (
    <Box className="flex items-center gap-2">
      <ExoAvatar
        picture={logo?.thumbnailUrl}
        name={nameShort || name}
        size={size === 'small' ? '30px' : '40px'}
        type={'company'}
      />
      {nameShort || name}
    </Box>
  );
};

const Contact = ({ data, size }) => {
  const { firstName, lastName, salutation, color } = data;
  return (
    <Box className="flex items-center gap-2">
      <ExoAvatar
        name={firstName + ' ' + lastName}
        size={size === 'small' ? '30px' : '40px'}
        type={'contact'}
        color={color}
      />
      {salutation + ' ' + firstName + ' ' + lastName}
    </Box>
  );
};

const CompanyLead = ({ data, size }) => {
  const { logo, name, nameShort } = data;
  return (
    <Box className="flex items-center gap-2">
      <ExoAvatar
        picture={logo?.thumbnailUrl}
        name={nameShort || name}
        size={size === 'small' ? '30px' : '40px'}
        type={'company'}
      />
      {nameShort || name}
    </Box>
  );
};
const PersonLead = ({ data, size }) => {
  const { firstName, lastName, salutation, color } = data;
  return (
    <Box className="flex items-center gap-2">
      <ExoAvatar
        name={firstName + ' ' + lastName}
        size={size === 'small' ? '30px' : '40px'}
        type={'contact'}
        color={color}
      />
      {salutation + ' ' + firstName + ' ' + lastName}
    </Box>
  );
};

const User = ({ data, size }) => {
  const { firstName, lastName, salutation, color, picture } = data;

  return (
    <Box className="flex items-center gap-2">
      <ExoAvatar
        picture={picture?.thumbnailUrl}
        name={firstName + ' ' + lastName}
        size={size === 'small' ? '30px' : '40px'}
        type={'contact'}
        color={color}
      />
      {salutation + ' ' + firstName + ' ' + lastName}
    </Box>
  );
};
